import React, {useEffect, useState} from 'react';
import * as styles from '../Styles/social-share.module.scss';
import PropTypes from 'prop-types';
import useWebShare from 'react-use-web-share';
import {
  FacebookShareButton, TwitterShareButton, RedditShareButton,
  LinkedinShareButton, FacebookIcon, TwitterIcon, LinkedinIcon, RedditIcon,
}
  from 'react-share';
import {ctaClickAction} from '../../Application/Shared/TrackActionService';


const WebsiteShare = ({courseUrl, courseName, coursePagetopSection,
  activeCourse, setActiveCourse}) => {
  const domain = process.env.WebsiteDomain;
  const pageUrl = `${domain}${courseUrl}`;
  const courseTitle = courseName;
  const options = {
    quoteText: `I am doing my course in ${courseTitle} with Upskillist.`,
    hashtagText: '#Upskillist',
    shareType: 'share course',
    courseSlug: 'courseslug',
  };

  // social share
  const {isSupported, loading, share} = useWebShare();
  const [showDetail, setShowDetail] = useState(false);
  const handleToggle = (passedCourseName) =>{
    setActiveCourse(passedCourseName);
    if (passedCourseName === activeCourse) {
      setShowDetail((prevState)=> !prevState);
    }
  };
  useEffect(() => {
    if (activeCourse !== courseTitle) {
      setShowDetail(false);
    } else {
      setShowDetail(true);
    }
  }, [activeCourse]);

  const shareUrl = pageUrl;

  /**
     *
     *
     * @param {any} mediaName
     */
  function socialShare(mediaName) {
    const title = courseName;
    const text =
      `Try the course in ${courseName} with Upskillist. You
      can also build your business, career or hobby with online
      certified courses. Check it out:`;
    const url = pageUrl;
    share({
      title, text, url,
    });
    ctaClickAction({
      'cta': {mediaName},
      'action': 'NativeSocialShare',
      'pageKind': 'WebsiteCoursePage',
    });
  }
  /**
     *
     *
     * @param {any} mediaName
     */
  function onShareWindowClose(mediaName) {
    ctaClickAction({
      'cta': {mediaName},
      'action': 'NativeSocialShare',
      'pageKind': 'WebsiteCoursePage',
    });
  }

  return (
    <div>
      {process.env.showShareInWebsiteCoursePage ===
        'true' &&
        <div className={`${styles.shareMedia}
              ${styles.hideOnMobile}`}>
          {!loading && isSupported ? (
            <div className={`${styles.box}
                library-brand-icon-new`}>
              <button
                aria-label='Share'
                onClick={() => handleToggle(courseTitle)}
                className={styles.shareBtn}>
                {showDetail === false ?
                <img alt="share" src=
                  "/images/home/new/share-btn.png" /> :
                  <i className='icon-new-close'></i>}
              </button>
              {showDetail ?
                <div className={styles.mediaBtn}>
                  <FacebookIcon size={32} round
                    onClick={() => {
                      socialShare('Facebook');
                      handleToggle();
                    }
                    } />
                  <TwitterIcon size={32} round
                    onClick={() => {
                      socialShare('Twitter');
                      handleToggle();
                    }
                    } />
                  <LinkedinIcon size={32} round
                    onClick={() => {
                      socialShare('Linkedin');
                      handleToggle();
                    }
                    } />
                  <RedditIcon size={32} round
                    onClick={() => {
                      socialShare('Reddit');
                      handleToggle();
                    }
                    } />
                </div> : ''
              }
            </div>
          ) : (
            <div className={`${styles.box}
              library-brand-icon-new`}>
              <button
                aria-label='Share'
                onClick={() => handleToggle(courseTitle)}
                className={styles.shareBtn}
              >
                {showDetail === false ?
                <img alt="share" src=
                  "/images/home/new/share-btn.png" /> :
                  <i className='icon-new-close'></i>}
              </button>
              {showDetail ?
                <div className={styles.mediaBtn}>
                  <FacebookShareButton url={shareUrl}
                    quote={options.quoteText}
                    hashtag={options.hashtagText}
                    onShareWindowClose=
                      {() => onShareWindowClose('Facebook')}
                  >
                    <FacebookIcon size={32} round
                    />
                  </FacebookShareButton>
                  <TwitterShareButton url={shareUrl}
                    title={courseName}
                    hashtag={options.hashtagText}
                    onShareWindowClose=
                      {() => onShareWindowClose('Twitter')}>
                    <TwitterIcon size={32} round
                    />
                  </TwitterShareButton>
                  <LinkedinShareButton url={shareUrl}
                    title={courseName}
                    summary={options.quoteText}
                    onShareWindowClose=
                      {() => onShareWindowClose('Linkedin')}>
                    <LinkedinIcon size={32} round
                    />
                  </LinkedinShareButton>
                  <RedditShareButton url={shareUrl}
                    title={courseName}
                    onShareWindowClose=
                      {() => onShareWindowClose('Reddit')}>
                    <RedditIcon size={32} round
                    />
                  </RedditShareButton>
                </div> :
                ''
              }
            </div>
          )}
        </div>
      }
      {process.env.showShareInWebsiteCoursePage ===
          'true' &&
        (coursePagetopSection ?
          <div className={`${styles.shareMedia}
          ${styles.showOnMobile}`}>
            <button aria-label='Share' onClick={() =>
              socialShare()}
            className={styles.shareBtnMobiletop}
            >Share with your friend
              <img alt="share" src =
                "/images/home/new/share-btn.png" />
            </button>
          </div> :
          <div className={`${styles.shareMedia}
                ${styles.showOnMobile}`}>
            <button onClick={() =>
              socialShare()}
            className={styles.shareBtnMobile}>
              <img alt="share" src=
                "/images/home/new/share-btn.png" />
            </button>
          </div>
        )
      }
    </div>
  );
};
WebsiteShare.propTypes = {
  courseUrl: PropTypes.string,
  courseName: PropTypes.string,
  coursePagetopSection: PropTypes.bool,
  activeCourse: PropTypes.string,
  setActiveCourse: PropTypes.func,
};

export default WebsiteShare;
